/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1CoachApplicationDecision
 */
export interface V1CoachApplicationDecision {
    /**
     *
     */
    decision: V1CoachApplicationDecisionDecisionEnum
    /**
     *
     */
    notes?: string
}

/**
 * @export
 */
export const V1CoachApplicationDecisionDecisionEnum = {
    Approve: 'approve',
    Decline: 'decline'
} as const
export type V1CoachApplicationDecisionDecisionEnum =
    (typeof V1CoachApplicationDecisionDecisionEnum)[keyof typeof V1CoachApplicationDecisionDecisionEnum]

/**
 * Check if a given object implements the V1CoachApplicationDecision interface.
 */
export function instanceOfV1CoachApplicationDecision(
    value: object
): value is V1CoachApplicationDecision {
    if (!('decision' in value) || value['decision'] === undefined) return false
    return true
}

export function V1CoachApplicationDecisionFromJSON(
    json: any
): V1CoachApplicationDecision {
    return V1CoachApplicationDecisionFromJSONTyped(json, false)
}

export function V1CoachApplicationDecisionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachApplicationDecision {
    if (json == null) {
        return json
    }
    return {
        decision: json['decision'],
        notes: json['notes'] == null ? undefined : json['notes']
    }
}

export function V1CoachApplicationDecisionToJSON(
    json: any
): V1CoachApplicationDecision {
    return V1CoachApplicationDecisionToJSONTyped(json, false)
}

export function V1CoachApplicationDecisionToJSONTyped(
    value?: V1CoachApplicationDecision | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        decision: value['decision'],
        notes: value['notes']
    }
}
